export default {
  surveyMetadata: {
    surveyClosed: 'The survey/test is closed for passing',
    canCloseTab: 'You have already completed this survey/test',
    canCloseTabFinished: 'The survey/test has been finished!',
    startSurvey: 'Start',
    continueSurvey: 'Continue',
    timeLimit: 'Test time:',
    finishPercentageHidden:
      'The result and the record of the test will not be displayed in the personal account, because the organizer preferred to hide the result',
    finishPercentageWithText:
      'Points scored: {validAnswersScore} out of {validVariantsScore} ({finishScore}%). {scoreText}',
    finishPercentage: 'Result: {validAnswersCount} from {validVariantsCount} ({finishPercent}%)',
    title: 'An existing active session was detected',
    text: 'You have already started the test in another tab or on another device.\nTo continue the test, return to the already open tab or click the "Continue here" button - in this case, all previous test sessions will be closed. Testing will continue from where it stopped',
    continue: 'Continue here',
    finishSurvey: 'Finish survey',
    canCloseSurveyTab: 'You have already completed this survey',
    canCloseSurveyTabFinished: 'The survey has been finished!',
    feedbackClosed:
      'You are not a participant in this survey, please log in with a different account or contact the organizer',
  },
};
